import AuthService from "../services/AuthService";

const RenderOnGuest: React.FC<{}> = ({ children }): any => (!AuthService.isLoggedIn()) ? children : null;

export default RenderOnGuest;
